var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.initialized
        ? [
            _vm.releaseListData.length > 0 &&
            _vm.getFilteredReleases(_vm.timeFrame).length > 0
              ? _vm._l(
                  _vm.getFilteredReleases(_vm.timeFrame),
                  function (release, releaseIndex) {
                    return _c("release-panel", {
                      key: releaseIndex,
                      attrs: {
                        delay: releaseIndex * 200,
                        "release-item": release,
                        "filter-by-content-type": _vm.filterByContentType,
                        "data-gtm": "releaseItem__openModal",
                      },
                      on: {
                        "show-release-modal": function ($event) {
                          return _vm.$emit("open-release-modal", release)
                        },
                      },
                    })
                  }
                )
              : [
                  _c("div", { staticClass: "alert alert-info" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.noDataInfo) +
                        "\n                "
                    ),
                  ]),
                ],
          ]
        : [
            _c(
              "div",
              {
                staticClass:
                  "panelCard panelCard--skeleton padding-all-10 margin-bottom-20 overflow-hidden pos-relative opacity-0 animated fadeIn",
                class: `panelCard--skeletonDelay${_vm.panelDelay}`,
              },
              [
                _c("span", [_vm._v(" ")]),
                _vm._v(" "),
                _c("h4", { staticClass: "hl-panelBoxSmall" }, [
                  _vm._v("\n \n                "),
                ]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }